/**
 * Theme cart: enforce Custom Sticker Patches minimum quantity (25) on line-item qty inputs.
 */
(function () {
  'use strict';

  var BOUND = 'data-csp-min-bound';
  var pendingByLineKey = Object.create(null);

  function getMin(input) {
    var min = parseInt(input.getAttribute('data-csp-min-qty') || input.getAttribute('min'), 10);
    return Number.isFinite(min) && min > 0 ? min : 25;
  }

  function inputsForLineKey(lineKey) {
    if (!lineKey) return [];
    var escaped = String(lineKey).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return Array.prototype.slice.call(
      document.querySelectorAll('input.quantity-input[data-csp-min-qty][data-line-key="' + escaped + '"]')
    );
  }

  function syncInputValues(lineKey, qty) {
    inputsForLineKey(lineKey).forEach(function (input) {
      if (parseInt(input.value, 10) !== qty) {
        input.value = String(qty);
      }
    });
  }

  function sectionIdsForCartUpdate() {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    var cartSection = document.querySelector('.shopify-section--main-cart');
    if (cartSection && cartSection.id) {
      var mainCartId = cartSection.id.replace('shopify-section-', '');
      if (sectionsToBundle.indexOf(mainCartId) === -1) {
        sectionsToBundle.push(mainCartId);
      }
    }
    return sectionsToBundle;
  }

  function replaceMainCartSection(cartContent) {
    var cartSection = document.querySelector('.shopify-section--main-cart');
    if (!cartSection || !cartContent || !cartContent.sections) return false;
    var sectionId = cartSection.id.replace('shopify-section-', '');
    var html = cartContent.sections[sectionId];
    if (!html) return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var updated =
      parsed.querySelector('.shopify-section--main-cart') || parsed.querySelector('.shopify-section');
    if (!updated) return false;
    cartSection.innerHTML = updated.innerHTML;
    return true;
  }

  function changeLineItemQuantity(lineKey, targetQuantity, sourceInput) {
    if (pendingByLineKey[lineKey]) {
      return pendingByLineKey[lineKey];
    }

    var lineItem = sourceInput && sourceInput.closest('line-item');
    lineItem &&
      lineItem.dispatchEvent(
        new CustomEvent('line-item:will-change', {
          bubbles: true,
          detail: { targetQuantity: targetQuantity }
        })
      );

    var promise = fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: targetQuantity,
        sections: sectionIdsForCartUpdate()
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cartContent) {
        replaceMainCartSection(cartContent);

        var lineItemAfterChange = (cartContent.items || []).filter(function (item) {
          return item.key === lineKey;
        });
        var quantity = lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity;

        lineItem &&
          lineItem.dispatchEvent(
            new CustomEvent('line-item:change', {
              bubbles: true,
              detail: { quantity: quantity, cart: cartContent }
            })
          );

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'line-item:change', cart: cartContent }
          })
        );

        bindAll();
      })
      .finally(function () {
        delete pendingByLineKey[lineKey];
      });

    pendingByLineKey[lineKey] = promise;
    return promise;
  }

  function enforceBelowMinimum(input) {
    var lineKey = input.getAttribute('data-line-key');
    if (!lineKey) return false;

    var min = getMin(input);
    var qty = parseInt(input.value, 10);
    if (Number.isFinite(qty) && qty >= min) {
      return false;
    }

    syncInputValues(lineKey, min);
    changeLineItemQuantity(lineKey, min, input);
    return true;
  }

  function onChange(event) {
    var input = event.target;
    if (!input.matches || !input.matches('input.quantity-input[data-csp-min-qty]')) {
      return;
    }

    var lineKey = input.getAttribute('data-line-key');
    var min = getMin(input);
    var qty = parseInt(input.value, 10);

    if (!Number.isFinite(qty) || qty < min) {
      event.stopPropagation();
      event.stopImmediatePropagation();
      syncInputValues(lineKey, min);
      changeLineItemQuantity(lineKey, min, input);
    }
  }

  function onBlur(event) {
    var input = event.target;
    if (!input.matches || !input.matches('input.quantity-input[data-csp-min-qty]')) {
      return;
    }
    window.setTimeout(function () {
      if (enforceBelowMinimum(input)) {
        event.stopPropagation();
      }
    }, 0);
  }

  function bindInput(input) {
    if (input.hasAttribute(BOUND)) return;
    input.setAttribute(BOUND, 'true');
    input.addEventListener('change', onChange);
    input.addEventListener('blur', onBlur);
  }

  function bindAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('input.quantity-input[data-csp-min-qty]'),
      bindInput
    );
  }

  function enforceAllOnLoad() {
    var seen = Object.create(null);
    Array.prototype.forEach.call(
      document.querySelectorAll('input.quantity-input[data-csp-min-qty]'),
      function (input) {
        var lineKey = input.getAttribute('data-line-key');
        if (!lineKey || seen[lineKey]) return;
        seen[lineKey] = true;
        enforceBelowMinimum(input);
      }
    );
  }

  function boot() {
    bindAll();
    enforceAllOnLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:change', function () {
    window.requestAnimationFrame(bindAll);
  });
})();
